import {defineAsyncComponent} from 'vue'

export default (app: any) => {
	app.component('dashboard-front-office', defineAsyncComponent(() => import(/* webpackChunkName: "DashboardFrontOffice" */ './DashboardFrontOffice.vue')))
	app.component('dashboard-hotelier', defineAsyncComponent(() => import(/* webpackChunkName: "DashboardHotelier" */ './DashboardHotelier.vue')))
}
